export function generateRoutePath(path, params) {
    if (path.toString() === '/')
        return path;
    var splittedPath = path.split('/').slice(1);
    var result = '';
    for (var _i = 0, splittedPath_1 = splittedPath; _i < splittedPath_1.length; _i++) {
        var segment = splittedPath_1[_i];
        if (segment.startsWith(':')) {
            var key = segment.slice(1);
            var parsedKey = typeof key === 'string' ? key.split('?')[0] : key;
            if (params[parsedKey]) {
                result += "/".concat(params[parsedKey]);
            }
        }
        else {
            result += "/".concat(segment);
        }
    }
    return result;
}
export var RoutePath;
(function (RoutePath) {
    RoutePath["ROOT"] = "/";
    RoutePath["LOGIN"] = "/login";
    RoutePath["LOGIN_REDIRECT"] = "/login/redirect";
    RoutePath["DEVICE_SUCCESS"] = "/device/success";
    RoutePath["COMPLETE_PROFILE"] = "/complete-profile";
    RoutePath["MIGRATION"] = "/migration";
    RoutePath["MIGRATION_AUTH"] = "/migration/auth";
    RoutePath["MIGRATION_SUCCESS"] = "/migration/success";
})(RoutePath || (RoutePath = {}));
